<style lang="scss" scoped>


</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            Niederschlagskorrektur löschen
        </template>
        
        <Alert type="info" >
            <template v-slot:title>Bitte beachten</template>
                Wenn Sie die Korrektur löschen, können sich Bewässerungsempfehlungen ändern.
        </Alert>
        
        <div class="row mt-1 mb-2">
            <div class="col-12">
                  <label class="form-label">Datum</label>
                  <div class="input-icon mb-3">
                    <input type="text" :value="formatDate(correction.date, 'DD.MM.YYYY')" class="form-control" placeholder="" disabled>
                    <span class="input-icon-addon">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><rect x="4" y="5" width="16" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="4" y1="11" x2="20" y2="11"></line><line x1="11" y1="15" x2="12" y2="15"></line><line x1="12" y1="15" x2="12" y2="18"></line></svg>
                    </span>
                  </div>  
            </div>
        </div>     
       <div class="row mt-1 mb-2">
            <div class="col-12">
                  <label class="form-label">Niederschlag </label>
                  <div class="input-icon mb-3">
                    <input type="text" :value="'{} mm (Wetterstation: {} mm)'.format(correction.value, correction.valueOriginal)" class="form-control" placeholder="" disabled>
                    <span class="input-icon-addon">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"></path><path d="M11 13v2m0 3v2m4 -5v2m0 3v2"></path>
                        </svg>
                    </span>
                  </div>
            </div>     
       </div>          
       <template v-slot:footer>
            <button type="button" class="btn me-auto" @click="closeModal">
                Abbrechen
            </button>
            <a href="#" class="btn btn-info ms-auto" @click="submit">
              <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
                Korrektur löschen
            </a>
            
        </template>
    </Modal>
</template>

<script>

import * as dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';

export default {
    name: 'Precipitation Alter Modal',
    components: {
        Modal,
        Alert
    },
    inject: [
        'state'
    ],
    props: {
        correction: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            
        }
    },
    computed: {
        
    },
    methods: {
        submit: function () {
            this.$emit('removeCorrection', this.correction);
            this.closeModal();            
        },
        openModal: function () {
            this.$refs.modal.openModal();            
        },
        closeModal: function () {
            this.$refs.modal.closeModal();            
        },
        formatDate: function (dateString, format) {
            return dayjs(dateString).format(format);
        },
    },
    watch: {
        
    },
    created: function () {
        
    },
    mounted: function () {
    
    }
}
</script>